import identity from 'transmute/identity';
import { createAsyncAction } from 'conversations-async-data/async-action/createAsyncAction';
import { getProductInfo } from '../api/getProductInfo';
import { fetchProductInfoActionTypes } from '../constants/productInfoActionTypes';
export const fetchProductInfo = createAsyncAction({
  requestFn: getProductInfo,
  actionTypes: fetchProductInfoActionTypes,
  toRecordFn: identity
});